import React from 'react'
import {useDraggable} from '@dnd-kit/core'
import {CSS} from '@dnd-kit/utilities'
import Card from './Card'

let Draggable = ({id, posX, posY, zoom, card, onContextMenu}) => {
  const {attributes, listeners, setNodeRef, transform} = useDraggable({id})

  // Compensate drag delta for the container's scale(zoom) transform
  let tx = transform ? transform.x / (zoom || 1) : 0
  let ty = transform ? transform.y / (zoom || 1) : 0

  const style = {
    transform: `translate(${tx}px, ${ty}px)`,
    position: 'absolute',
    left: posX,
    top: posY,
  }

  return (
    <button
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      onMouseDown={e => e.stopPropagation()}
      onContextMenu={onContextMenu}>
      <Card card={card} />
    </button>
  )
}

export default Draggable
